// @ts-check
'use_strict';
import { BaseShippingEstimatorView } from './BaseShippingEstimatorView';
export declare var $;

/**
 * The Cart Shipping Estimator View handles the shipping estimation modal on the cart page.
 */
export class CartEstimatorView extends BaseShippingEstimatorView {
    /**
     * Finds all of the elements needed for this view to run.
     *
     * @returns {void}
     */
    protected find_elements(): void {
        this.shipping_estimator.select_option_callback = this.shipping_option_selected.bind(this);
        this.shipping_estimator.product_page = true;

        // Get Address for estimation from cart.
        this.elements.name = document.getElementById('js-delivery-address-name');
        this.elements.phone = document.getElementById('js-delivery-address-phone');
        this.elements.zipcode_input = document.getElementById('js-delivery-address-zipcode');
        this.elements.address1 = document.getElementById('js-delivery-address-address1');
        this.elements.city = document.getElementById('js-delivery-address-city');
        this.elements.country = document.getElementById('js-delivery-address-country');
        this.elements.state = document.getElementsByClassName('js-delivery-address-state')[0];
        this.elements.zipcode_input_button = document.getElementById('js-shipping-zipcode-button');

        this.elements.selected_production_option = document.getElementById('js-selected-production-option');
        this.elements.results_view_button = document.getElementById('js-carrier_results_view_button');
        this.elements.opener_button = document.getElementById('js-cart-shipping-estimator-opener-link');
        this.elements.address_book_full_address_button = document.getElementById(
            'js-delivery-enter-full-address-button'
        );
        this.elements.order_type = document.getElementsByClassName('js-cart-configuration-order-type');

        // Production and shipping options elements.
        this.elements.production_and_shipping_main_container = document.getElementById(
            'js-production-and-shipping-main-container'
        );
        this.elements.production_times_container = document.getElementById('js-production-times-container');
        this.elements.production_times = <HTMLInputElement>document.getElementById(
            'js-shipping-estimate-production-times-input'
        );

        // Address and carrier locations elements.
        this.elements.use_address_or_carrier_locations_buttons = document.getElementsByClassName(
            'js-use-address-or-carrier-locations-button'
        );
        this.elements.address_and_carrier_locations_container = document.getElementById(
            'js-address-and-carrier-locations-container'
        );

        // Address elements.
        this.elements.address_container = document.getElementById('js-product-page-address-container');
        this.elements.address_zipcode_input = document.getElementById('js-delivery-address-zipcode');
        this.elements.use_address_button = document.getElementById('js-use-address-button');

        // Carrier locations elements.
        this.elements.address_carrier_container = document.getElementsByClassName('js-address-carrier-container');
        this.elements.carrier_locations_container = document.getElementById(
            'js-product-page-carrier-locations-container'
        );

        // Back button.
        this.elements.section_back_button = document.getElementById('js-section-back-button');

        this.elements.subtotal_discount = document.getElementById('js-checkout-subtotal-discount');
        this.elements.taxes_subtotal = document.getElementById('js-checkout-taxes-subtotal');

        this.elements.tax_display_span = document.querySelector(
            '.ty-statistic-list-tax > .ty-cart-statistic__value > span'
        );

        const deleteButtons = document.getElementsByClassName('ty-cart-content__product-delete');

        for (const button of deleteButtons) {
            button.addEventListener('click', () => {
                $.toggleStatusBox('show', {
                    statusContent: '<span class="ty-ajax-loading-box-with__text-wrapper"> Removing Item </span>',
                    statusClass: 'ty-ajax-loading-box_text_block'
                });
            });
        }

        this.recalculate_total();
    }

    /**
     * Called when a shipping price is selected.
     * It is used to update the page's shipping prices, etc.
     *
     * @param {HTMLElement} selected_element The element selected from the shipping prices.
     * @returns {void}
     */
    private shipping_option_selected(selected_element: HTMLElement): void {
        if (selected_element !== null) {
            const record_data = JSON.parse(selected_element.dataset.rec);
            const shipping_amount = record_data.amount;
            this.elements.opener_button.innerHTML = (
                shipping_amount === 'undefined'
            ) ? '$0' : `$${shipping_amount.toFixed(2)}`;

            if (this.production_price > 0) {
                this.elements.opener_button.innerHTML += `<br>Rush&nbsp;$${this.production_price.toFixed(2)}`;
            }

            this.recalculate_total(shipping_amount);
        }
    }

    /**
     * Recalculate and display the total cost in the cart.
     *
     * @param {number} shipping_amount The shipping amount from the selected shipping element.
     * @returns {void}
     */
    private recalculate_total(shipping_amount: number = 0): void {
        const total_element = document.getElementById('sec_cart_total');
        const subtotal_element = <HTMLInputElement>document.getElementById('js-shipping-estimate-subtotal');
        const subtotal = parseFloat(subtotal_element.value);

        let subtotal_discount = 0;
        if (this.elements.subtotal_discount) {
            subtotal_discount = -parseFloat(this.elements.subtotal_discount.value);
        }

        let taxes_subtotal = 0;
        if (this.elements.taxes_subtotal && this.elements.taxes_subtotal.value > 0) {
            taxes_subtotal = parseFloat(this.elements.taxes_subtotal.value);
            const tax_rate = taxes_subtotal / subtotal;
            const rush_and_sh_tax = (this.production_price + shipping_amount) * tax_rate;
            taxes_subtotal += rush_and_sh_tax;
            this.elements.tax_display_span.textContent = taxes_subtotal.toFixed(2).replace(
                /\d(?=(\d{3})+\.)/g,
                '$&,'
            );
        }

        total_element.innerHTML = `${(
            shipping_amount +
            subtotal +
            taxes_subtotal +
            subtotal_discount +
            (this.production_price || 0)
        ).toFixed(2)}`;
    }
}
